var documentReady = new Promise((resolve, reject) => {
  switch(document.readyState) {
    case "complete":
    case "interactive":
      resolve();
      break;
    case "loading":
      document.addEventListener("DOMContentLoaded", resolve, {once: true});
  }
});

function addToggler(toggler) {
  document.getElementById(toggler.getAttribute("rel")).style.display =
    toggler.checked ? "revert" : "none";
}


function addInputTogglers() {
  document.querySelectorAll(".toggler").forEach(function(toggler) {
    addToggler(toggler);
    toggler.addEventListener("click", function(ev) {
      addToggler(ev.target);
    });
  });
}

documentReady.then(addInputTogglers);

function check_consent(element_id) {
  const el = document.querySelector(element_id);
  if (!el) return true;

  const msg = el.parentElement.querySelector(".invalid-feedback");
  if (el.checked) {
    el.parentElement.classList.remove("has-error");
    msg.classList.add("d-none");
    return true;
  } else {
    el.parentElement.classList.add("has-error");
    msg.classList.remove("d-none");
    return false;
  }
}

function submit_order(ev) {
  ev.preventDefault();
  ev.stopPropagation();

  let ok =
      check_consent('#accept_agb') &&
      check_consent('#accept_license') &&
      check_consent('#accept_revocation') &&
      check_consent('#accept_data_processing') &&
      check_consent('#accept_revocation_agreement');
  if (ok) {
    ev.target.disabled = true;
    document.order.requestSubmit();
  }
}

function submit_address() {
  if ($("#form_customer_vat_number") && $("#form_customer_vat_number").val() != '') {
    $('#customer_vat_number_wait').show(); //effect('slide', 'slow', 500);
  }
  setTimeout(function() {
    $(".address_form").submit();
  }, 500);
}

window.submit_address = submit_address;
window.submit_order = submit_order;
